var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34619 17.5973C1.34807 25.5929 7.12649 32.4008 14.9747 33.6539V22.2945H10.8766V17.5973H14.9796V14.0215C14.7961 12.3272 15.3713 10.6386 16.5491 9.41361C17.7268 8.18866 19.3851 7.55436 21.0742 7.68274C22.2866 7.70244 23.4959 7.81109 24.6925 8.00781V12.0045H22.6508C21.9478 11.9119 21.2411 12.1454 20.7298 12.6395C20.2184 13.1335 19.9576 13.8344 20.021 14.5449V17.5973H24.4971L23.7815 22.2961H20.021V33.6539C28.5087 32.3042 34.4606 24.5045 33.5647 15.9054C32.6689 7.30627 25.239 0.918007 16.6576 1.36863C8.07623 1.81925 1.34756 8.951 1.34619 17.5973Z",
    fill: "#FF9D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.1cf08d671285a8e26553d9cae2fdcffe.svg";
export { ForwardRef as ReactComponent };